import { Entity, Index, PrimaryColumn, Column, BaseEntity } from "typeorm";

@Entity({ name: 'inventory_purchase_orders' }) 
@Index(['business_id', 'location_id', 'id'])
@Index(['business_id', 'location_id', 'last_modified'])
@Index(['business_id', 'location_id', 'isSynced'])
@Index(['business_id', 'location_id', 'code'])
export class InventoryPurchaseOrder extends BaseEntity {
  @PrimaryColumn()
  id: string;

  @Column() 
  @Index()
  business_id: string;

  @Column({ nullable: true })
  @Index()
  operator_id: string;

  @Column() 
  @Index()
  location_id: string;

  @Column()
  @Index()
  inventory_location_id: string;

  @Column({ nullable: true })
  @Index()
  inventory_supplier_id: string;

  @Column() 
  @Index()
  code: string;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  subtotal: string;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  additional_cost: string;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  total: string;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  paid_amount: string;

  @Column({ default: 'unpaid' })
  payment_status: string;

  @Column({ default: 'cash' })
  payment_method: string;

  @Column({ type: 'text', nullable: true })
  notes: string;

  @Column({ default: 'pending' })
  status: string;

  @Column()
  purchased_at: Date;

  @Column({ nullable: true })
  expected_at: Date;

  @Column({ nullable: true })
  received_at: Date;

  @Column({ type: 'text', nullable: true })
  metadata: string;

  @Column()
  created_at: Date;

  @Column({ nullable: true })
  updated_at: Date;

  @Column({ type: 'bigint', nullable: true })
  @Index()
  last_modified: number;

  @Column({ default: false })
  @Index()
  isSynced: boolean;
}